import WorkoutsTable from './WorkoutsTable';

export default WorkoutsTable;
